import { gql } from '@apollo/client'

export const Query = gql`
  query TaxRates($companyId: ID!, $filters: TaxRateFilters, $after: String, $before: String, $first: Int, $last: Int) {
    taxRates(companyId: $companyId, filters: $filters, after: $after, before: $before, first: $first, last: $last) {
      nodes {
        id
        name
        rate
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
